import { store } from '@/redux/lib/configureStore';
import getLogTimeMachine from '../../workflowLogs/lib/getLogTimeMachine';
import selectors from '@/redux/selectors/selectors';

const getTimeMachineEntry = ({ logId, operationLog }) => {
  const state = store.getState();
  const output = selectors.workflowLogOutputById(state, logId);
  const operationLogs = selectors.workflowOperationLogsByLogId(state, logId);
  const activeLog = selectors.workflowLogsById(state, logId);
  const triggerStep = activeLog?.meta?.triggerStep;
  // Same trigger inputs as the log viewer (DetailsLogSection): a manual run has a trigger entry at
  // index 0 only when `invokedBy` is passed, and without it every index here is one behind the viewer.
  const invokedBy = activeLog?.meta?.invokedBy;
  const manualUserId = invokedBy?.startsWith('manual-') ? invokedBy.split('-')[1] : null;

  const { timeMachine } = getLogTimeMachine({ output, operationLogs, time: 0, triggerStep, invokedBy, manualUserId });

  const matchingEntry = timeMachine?.find((entry) => entry.step?.stepInstanceId === operationLog?.stepInstanceId);

  if (!matchingEntry) {
    return null;
  }

  return {
    index: matchingEntry.index
  };
};

export default getTimeMachineEntry;
